import React from "react";
import PropTypes from "prop-types";
import { UserIdModal } from "@gonoodle/gn-universe-ui";
import { useMutation, useQueryClient } from "react-query";

import api from "../api";
import { AnalyticsPropTypes } from "../types/analytics";
import { QUERY_KEYS } from "../constants";
import { useLogEvent } from "../contexts/Analytics";

function UserSelfIdModal({ open, onOpenChange, analyticsProps }) {
  const client = api();
  const queryClient = useQueryClient();

  const { mutate: updateUser, isSuccess: updateUserSucceeded } = useMutation(
    (selectedUserType) => client.updateUser({ userType: selectedUserType }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.USER);
      },
    },
  );

  useLogEvent({
    event: "User Identification Modal Viewed",
    properties: analyticsProps,
    options: {
      enabled: !!open,
    },
  });

  useLogEvent({
    event: "User Identified",
    properties: analyticsProps,
    options: {
      enabled: !!updateUserSucceeded,
    },
  });

  return (
    <UserIdModal
      open={open}
      heading="Quick question!"
      description="How are you using GoNoodle? Your answer will help us give you the best experience."
      buttonText="I'm using GoNoodle as an educator"
      subText="I'm using GoNoodle for my family"
      onClick={updateUser}
      onOpenChange={onOpenChange}
    />
  );
}

UserSelfIdModal.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  analyticsProps: AnalyticsPropTypes.isRequired,
};

UserSelfIdModal.defaultProps = {
  open: false,
  onOpenChange: () => {},
};

export default UserSelfIdModal;
